import React from "react";

const Footer = () => {
  return (
    <footer id='footer' className='footer'>
      <div className='copyright'>
        © Copyright{" "}
        <strong>
          <span>YourAdmin</span>
        </strong>
        . All Rights Reserved
      </div>
      <div className='credits'>
        Designed by <a href='#' className="h5">Hyper7Developers</a>
      </div>
    </footer>
  );
};

export default Footer;
